import { z } from "zod";
import { AbstractExtractSchema } from "./abstract/abstractExtract.entities";
import { AwIdSchema } from "../traits";

export enum ExtractScheduleTypeSchemaEnum {
	ExtractScheduleType = "ExtractScheduleType"
};

export const ExtractScheduleTypeSchema = AbstractExtractSchema
	.merge(AwIdSchema)
	.merge(z.object({
		"@id": z.string(), // "/api/extract_schedule_types/1"
		"@type": z.string(), // "ExtractScheduleType"
		id: z.number(), // 1
		label: z.string(), // "Adaptation"
		schedule_status: z.string(), // "LIVRAISON_SAV"
		background_color: z.string(), // "124323535"
		duration: z.string(), // "30"
		action: z.string(), // "ADAPTATION"
	}))
	.describe(ExtractScheduleTypeSchemaEnum.ExtractScheduleType);

export type ExtractScheduleType = z.infer<typeof ExtractScheduleTypeSchema>;
